/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';

interface HeaderWidgetProps {
  message?: string;
}

const HeaderWidgetStyle = styled.div({
  background: "#C5F7E2",
  padding: '10px',
  borderRadius: '5px',
  alignItems: 'center',
  textAlign: 'center',
});

export const HeaderWidget: React.FC<HeaderWidgetProps> = ({ message }: HeaderWidgetProps) => {
  if (!message) return null;
  return (
    <HeaderWidgetStyle>
      {message}
    </HeaderWidgetStyle>
  );
};